module.exports = __webpack_public_path__ + "static/media/supporting_3.a9069507.png";